import { useContext } from 'react';

import MetadataContext, { IMetadataContext } from './MetadataContext';

export default function useMetadata() {
  return useContext<IMetadataContext>(MetadataContext);
}
